import { Component, inject, computed } from '@angular/core';
import { FileTableComponent, BreadcrumbListComponent } from '@r1-compass-library/components';
import { MatMenuModule } from '@angular/material/menu';
import { ContentAssetListStore } from '../store/content-asset-list.store';
import { ContentAsset } from '@r1-compass-library/models';
import { AppConstants } from '../../app.constants';
import { MatButtonModule } from '@angular/material/button';
import { ContentAssetFolderService, ContentAssetService } from '@r1-compass-library/services';
import { AssetListComponent } from '../../asset-list.component';
import { FileTableEntry } from '@r1-compass-library/components/file-table/file-table.model';

@Component({
    selector: 'r1-compass-app-content-library-list',
    imports: [BreadcrumbListComponent, FileTableComponent, MatButtonModule, MatMenuModule],
    templateUrl: './content-library-list.component.html',
    styleUrls: ['./content-library-list.component.scss'],
})
export class ContentLibraryListComponent extends AssetListComponent<
    ContentAsset,
    ContentAssetService,
    ContentAssetFolderService,
    ContentAssetListStore
> {
    override EDIT_ASSET_PATH: string = AppConstants.ContentLibraryDefinitionComponent.path;
    override BASE_PATH = '/content-library';
    override columns = AppConstants.folderNameColumnsForAssets;

    constructor() {
        super(inject(ContentAssetListStore), inject(ContentAssetService), inject(ContentAssetFolderService));
    }

    override sortedFileTableEntries = computed<FileTableEntry[]>(() =>
        this.assetListSortingService.defaultSortWithEnabled(this.vm().contentWithActions)
    );
}
